var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(i){return _c('div',{key:i,staticClass:"step-item",class:{active: i == _vm.current}},[_vm._v(_vm._s(i))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }